import React from "react";
import gallery1 from '../img/gallery-1.jpeg'
import gallery2 from '../img/gallery-2.jpeg'
import gallery3 from '../img/gallery-3.jpeg'
import gallery4 from '../img/gallery-4.jpeg'
import gallery5 from '../img/gallery-5.jpeg'
import gallery6 from '../img/gallery-5.jpeg'


const galleries = [
  {
    icon: "fas fa-city", // Represents buildings or cityscape
    title: "Emperia Icon – Nerul",
    image: gallery1,
  },
  {
    icon: "fas fa-door-open", // Represents interiors
    title: "Interior View – Emperia Icon",
    image: gallery2,
  },
  {
    icon: "fas fa-dumbbell", // Perfect icon for a gym/fitness center
    title: "GYM – Emperia Icon, Nerul",
    image: gallery3,
  },
  {
    icon: "fas fa-building", // Represents commercial towers/offices
    title: "Commercial Tower – Emperia Icon",
    image: gallery4,
  },
  {
    icon: "fas fa-map-marker-alt", // Symbolizes location/address
    title: "Prime Business Address – Nerul",
    image: gallery5,
  },
  {
    icon: "fas fa-drafting-compass", // Ideal for "Design Build" concept
    title: "Design Build",
    image: gallery1,
  },
];


const Gallery = () => {
  return (
    <div className="container-fluid service bg-light pb-5">
      <div className="container pb-5">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: "800px" }}>
          {/* <p className="text-uppercase text-secondary fs-5 mb-0">Our galleries</p> */}
          <h2 className="display-4 text-capitalize mb-3">
            Gallery
          </h2>
        </div>
        <div className="row g-4">
          {galleries.map((service, index) => (
            <div className="col-lg-4" key={index}>
              <div className="service-item">
                <div className="service-img">
                  <img
                    src={service.image}
                    className="img-fluid w-100"
                    alt={service.title}
                  />
                </div>
                <div className="service-content text-center p-4">
                  {/* <div
                    className="bg-secondary btn-xl-square mx-auto d-flex align-items-center justify-content-center"
                    style={{ width: "120px", height: "120px" }}
                  >
                  
                    <i className={`${service.icon} text-primary fa-4x`}></i>
                  </div> */}


{/* 
                  <a href="#" className="d-block fs-4 my-4">
                    {service.title}
                  </a>
                  <p className="text-white mb-4">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Mollitia, minima!
                  </p>
                  <a className="btn btn-secondary py-2 px-4" href="#">
                    Read More
                  </a> */}



                </div>
                <div className="service-tytle d-flex justify-content-between align-items-center ps-4 pe-4">


                  <h4>{service.title}</h4>
                  <div
                    className="btn-xl-square bg-secondary d-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className={`${service.icon} text-primary fa-2x`}></i>
                  </div>


                </div>
              </div>
            </div>
          ))}

          <div className="col-12 text-center">
            <a className="btn btn-secondary py-3 px-5 mt-4" href="#">
              More Gallery
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
